import { render, staticRenderFns } from "./ChangeTransactionCategorySettingsPopup.vue?vue&type=template&id=2deb5abc&scoped=true&"
import script from "./ChangeTransactionCategorySettingsPopup.vue?vue&type=script&lang=js&"
export * from "./ChangeTransactionCategorySettingsPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTransactionCategorySettingsPopup.vue?vue&type=style&index=0&id=2deb5abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb5abc",
  null
  
)

export default component.exports